// extracted by mini-css-extract-plugin
export default {"report_wrapper":"MeasurementsAllClients_report_wrapper__1o4v-","ol_wrappe":"MeasurementsAllClients_ol_wrappe__J6Yae"};